import apiClient from "./index";

// User Profile Interfaces
export interface UserProfile {
  id: number;
  fullName: string;
  email: string;
  phoneNumber: string;
  acceptTerms: boolean;
  googleId: string | null;
  createdAt: string;
  updatedAt: string;
}

export interface UpdateProfilePayload {
  fullName?: string;
  phoneNumber?: string;
}

export interface ProfileResponse {
  message: string;
  data: UserProfile;
}

/**
 * Get current user's profile
 * @returns Promise<ProfileResponse>
 */
export const getUserProfile = () => {
  return apiClient.get<ProfileResponse>("/users/profile");
};

/**
 * Update current user's profile
 * @param payload - Object containing fullName and/or phoneNumber
 * @returns Promise<ProfileResponse>
 */
export const updateUserProfile = (payload: UpdateProfilePayload) => {
  return apiClient.put<ProfileResponse>("/users/profile", payload);
};

/**
 * Get user by ID
 * @param userId - User ID
 * @returns Promise<ProfileResponse>
 */
export const getUserById = (userId: number) => {
  return apiClient.get<ProfileResponse>(`/users/${userId}`);
};

/**
 * The account holder's own data, as a ZIP (worklist task 160).
 *
 * A blob rather than a link, because the endpoint is cookie-authenticated —
 * pointing an <a href> at it would work in most browsers but bypass the
 * client's error handling, so a 403 or 500 would render as a corrupt download.
 */
export const downloadMyDataExport = async (): Promise<Blob> => {
  const response = await apiClient.get("/users/me/export", {
    responseType: "blob",
  });
  return response.data as Blob;
};
